<template>
  <div>
    <hs-breadcrumb :breadcrumb="breadcrumb"></hs-breadcrumb>
    <Card :bordered="false" :style="{marginBottom:'10px'}">
      <div class="hs-screen-row">
        <Select v-model="params.changeType" placeholder="资金流水类型" clearable style="width:200px">
          <Option value="">全部</Option>
          <Option value="1">充值增加</Option>
          <Option value="2">回收付款</Option>
          <Option value="3">活动付款</Option>
        </Select>
      </div>
      <div class="hs-screen-row">
        <DatePicker @on-change="changeDate" v-model="dateInit" type="daterange" :editable="false"
                    separator=" ~ " split-panels transfer
                    placeholder="创建时间" style="width: 200px"></DatePicker>
      </div>
      <div class="hs-screen-row">
        <Button type="primary" @click="findList">查询</Button>
      </div>
      <div class="hs-screen-row">
        <Button @click="resetScreen">重置</Button>
      </div>
    </Card>

    <Card :bordered="false">
      <div style="text-align:left">
        <h1>余额：{{tenant.balance}}</h1>
      </div>
    </Card>

    <Card :bordered="false" :style="{marginBottom:'10px'}">
      <!--标题-->
      <div slot="title">
        <div class="hs-screen-box">
          <div>资金流水列表</div>
          <div>
            <ButtonGroup>
              <Button @click="findList">
                <Icon type="md-refresh" size="15"/>
              </Button>
            </ButtonGroup>
          </div>
        </div>
      </div>
      <!--表格数据-->
      <Table :columns="columns" :data="data" size="small" :stripe="true" :loading="isTableLoading">

        <template slot-scope="{ row, index }" slot="changeType">
          <Tag color="green" v-if="row.changeType === 1" size="default">充值增加</Tag>
          <Tag color="volcano" v-if="row.changeType === 2" size="default">回收付款</Tag>
          <Tag color="volcano" v-if="row.changeType === 3" size="default">活动付款</Tag>
        </template>
      </Table>
      <!--分页-->
      <div class="hs-page">
        <Page :total="total" show-sizer show-total transfer @on-change="changePage"
              @on-page-size-change="changePageSize"/>
      </div>
    </Card>
  </div>
</template>

<script>
import hsBreadcrumb from '@/components/hs-breadcrumb';

export default {
  name: "admin",
  data() {
    return {
      total: 0,
      isTableLoading: false,
      dateInit: '',
      // 参数
      params: {
        page: 1,
        rows: 10,
        changeType: '',
        startTime: '',
        endTime: ''
      },
      // 表格列
      columns: [
        {
          type: 'index',
          width: 60,
          align: 'center'
        },
        {
          title: 'ID',
          minWidth: 120,
          key: 'tenantCapitalRecordId'
        },
        {
          title: '变动金额',
          minWidth: 120,
          key: 'changeAmount'
        },
        {
          title: '变动后余额',
          minWidth: 220,
          key: 'afterAmount'
        },
        {
          title: '资金流水类型',
          minWidth: 120,
          slot: 'changeType'
        },
        {
          title: '描述',
          minWidth: 220,
          key: 'title'
        },
        {
          title: '创建时间',
          key: 'createTime',
          width: 150
        },
      ],
      // 表格数据
      data: [],
      // 面包屑
      breadcrumb: [
        {name: '首页', url: '', icon: 'ios-home-outline', size: 18},
        {name: '系统管理', url: '', icon: '', size: 0},
        {name: '资金流水列表', url: '', icon: '', size: 0}
      ],
      tenant: {}
    }
  },
  created() {
    // 租户流水-列表查询
    this.findList();
    this.getInfo();
  },
  methods: {
    // 租户流水-列表查询
    findList() {
      this.isTableLoading = true;
      this.axios.post('/tenant/capitalRecord', this.params).then(res => {
        this.isTableLoading = false;
        if (res.status == 200) {
          this.total = res.data.total;
          this.data = res.data.rows;
        }
        if (res.status == 500) {
          this.$Notice.error({
            title: '服务器内部错误',
            desc: '查询资金流水列表接口报错',
            duration: 0
          });
        }
      })
    },
    // 租户详情查询
    getInfo() {
      this.axios.post('/tenant/getTenantInfo').then(res => {
        if (res.status == 200) {
          this.tenant = res.data;
        }
        if (res.status == 500) {
          this.$Notice.error({
            title: '服务器内部错误',
            desc: '查询租户详情接口报错',
            duration: 0
          });
        }
      })
    },
    // 日期条件赋值
    changeDate(e) {
      this.params.startTime = e[0];
      this.params.endTime = e[1];
    },
    // 重置筛选条件
    resetScreen() {
      this.params.username = '';
      this.params.roleId = '';
      this.params.isDisable = '';
    },
    // 改变页数
    changePage(e) {
      this.params.page = e;
      this.findList();
    },
    // 改变页容量
    changePageSize(e) {
      this.params.rows = e;
      this.findList();
    },
  },
  components: {
    hsBreadcrumb,
  }
}
</script>

<style scoped>

</style>